module.exports = __webpack_public_path__ + "img/icon-check.293831b5.svg";